import { FiTruck as Car, FiX as X, FiArrowUpRight as ArrowUpRight } from 'react-icons/fi';
import { useState, useRef, useEffect } from 'react';
import { useLanguageContext } from '../context/languageContext';
import LivePrices from './LivePrices';

export const affiliateUrl = 'https://www.discovercars.com/albania?a_aid=denismimini&chan=hira-menu';
export const cars = [
  { name: 'Skoda Fabia', image: 'https://www.discovercars.com/images/car/4241/296.png' },
  { name: 'Ford Focus', image: 'https://ppl-img.discovercars.com/images/296/2eeea7e7a8e540c49f30198433724bc1.png' },
  { name: 'Skoda Yeti', image: 'https://ppl-img.discovercars.com/images/296/2dcda4f7c9af4c3eaa85f35f28cb7b07.png' },
];

export default function CarRentalFloat() {
  const { language } = useLanguageContext();
  const [expanded, setExpanded] = useState(false);
  const dialog = useRef(null);
  useEffect(() => {
    if (!expanded) return;
    const element = dialog.current;
    const previous = document.body.style.overflow;
    element.showModal();
    document.body.style.overflow = 'hidden';
    return () => { element.close(); document.body.style.overflow = previous; };
  }, [expanded]);
  const copy = language === 'sq' ? {
    title: 'Makina me qira', description: 'Krahasoni makina me qira në Shqipëri me DiscoverCars.',
    action: 'Shikoni makinat', close: 'Mbyll', disclosure: 'Lidhje affiliate: mund të marrim komision nga rezervimet.',
  } : language?.toLowerCase() === 'it' ? {
    title: 'Noleggia un’auto', description: 'Confronta le auto a noleggio in Albania con DiscoverCars.',
    action: 'Scopri le auto', close: 'Chiudi', disclosure: 'Link affiliato: potremmo ricevere una commissione sulle prenotazioni.',
  } : {
    title: 'Rent a car', description: 'Compare car rentals in Albania with DiscoverCars.',
    action: 'Find a car', close: 'Close', disclosure: 'Affiliate link: we may earn a commission on bookings.',
  };
  if (!affiliateUrl) return null;

  return <>
    <dialog ref={dialog} id="car-rental-panel" aria-labelledby="rental-title" onClose={() => setExpanded(false)} onCancel={() => setExpanded(false)} className="m-auto max-h-[85dvh] w-[calc(100%_-_24px)] max-w-3xl overflow-y-auto rounded-2xl bg-white p-4 shadow-2xl backdrop:bg-black/60 sm:p-6">
      <div className="flex items-center justify-between gap-2">
        <h2 id="rental-title" className="text-xl font-bold text-slate-900">DiscoverCars</h2>
        <button type="button" autoFocus aria-label={copy.close} onClick={() => setExpanded(false)} className="flex h-11 w-11 items-center justify-center rounded-full bg-stone-100"><X className="h-5 w-5" aria-hidden="true" /></button>
      </div>
      <p className="mt-2 text-sm leading-relaxed text-slate-600">{copy.description}</p>
      {expanded && <div className="mt-4 flex snap-x snap-mandatory gap-3 overflow-x-auto pb-3 sm:grid sm:grid-cols-3">
        {cars.map(car => <a key={car.name} href={affiliateUrl} target="_blank" rel="sponsored noopener noreferrer" className="w-[85%] shrink-0 snap-start overflow-hidden rounded-xl border border-slate-200 bg-white sm:w-auto">
          <img src={car.image} alt={car.name} width="300" height="160" className="h-36 w-full bg-slate-50 object-contain p-3" />
          <div className="p-3">
            <h3 className="font-bold text-slate-900">{car.name}</h3>
            <p className="mt-1 text-xs text-slate-500">{language === 'sq' ? 'ose e ngjashme' : language?.toLowerCase() === 'it' ? 'o simile' : 'or similar'}</p>
            <span className="mt-3 flex min-h-[44px] items-center justify-between rounded-lg bg-blue-700 px-3 py-2 text-sm font-bold text-white">{copy.action}<ArrowUpRight className="h-4 w-4" aria-hidden="true" /></span>
          </div>
        </a>)}
      </div>}
      {expanded && <LivePrices provider="cars" />}
      <a href={affiliateUrl} target="_blank" rel="sponsored noopener noreferrer" className="mt-4 flex min-h-[48px] items-center justify-between rounded-xl bg-blue-700 px-4 py-3 text-sm font-bold text-white hover:bg-blue-800">{copy.action}<ArrowUpRight className="h-4 w-4" aria-hidden="true" /></a>
      <p className="mt-3 text-xs leading-relaxed text-slate-500">{copy.disclosure}</p>
    </dialog>
    <button type="button" aria-expanded={expanded} aria-controls="car-rental-panel" onClick={() => setExpanded(true)} className="fixed bottom-24 right-4 z-40 flex min-h-[48px] items-center gap-2 rounded-full bg-blue-700 px-4 py-3 text-sm font-bold text-white shadow-lg hover:bg-blue-800 md:right-6"><Car className="h-5 w-5" aria-hidden="true" />{copy.title}</button>
  </>;
}
